// extracted by mini-css-extract-plugin
export default {"pagination":"List_pagination__WQttD","controls":"List_controls__zTkEB","search":"List_search__ayTYP","filter":"List_filter__LQCFW","action":"List_action__90rdF"};